// extracted by mini-css-extract-plugin
export default {"rootContainer":"MainMenu_rootContainer__plmhe"};